<template>
  <div id="app">
    <HeaderSection/>
    <router-view />
    <FooterSection/>
  </div>
</template>

<script setup>
  import HeaderSection from './components/Layaout/HeaderSection.vue';
  import FooterSection from './components/Layaout/FooterSection.vue';
</script>

<script>
  export default {
    name: 'App'
  }
</script>
